module.exports = __webpack_public_path__ + "media/styles/images/svg/arrow-down-gray-dark-a541a282a3cbe3def6757ad16c72d9f4.svg";